module.exports = __webpack_public_path__ + "img/shutterstock_1023277171_transparent_background.f518cdab.png";